.trophyCaseCard {
    border-bottom: 1px solid var(--mantine-color-dark-5);
}
